import { render, staticRenderFns } from "./RejectedList.vue?vue&type=template&id=40992016&scoped=true"
import script from "./RejectedList.vue?vue&type=script&lang=js"
export * from "./RejectedList.vue?vue&type=script&lang=js"
import style0 from "./RejectedList.vue?vue&type=style&index=0&id=40992016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40992016",
  null
  
)

export default component.exports